<template>
  <el-dialog title="修改人员信息" :visible.sync="dialogInfo.show" @close="closeDialog" :close-on-click-modal="false"
    destroy-on-close width="45%">
    <el-form ref="form" :model="form" label-width="80px" size="small">
      <el-form-item label="房间号：">
        <el-input v-model="form.roomNumber" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="班内职务：">
        <el-input v-model="form.classPost" maxlength="50" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消" />
      <butn btntype="primary" @click="sureEdit" title="确认" />
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { $LiaisonUserUpdate } from '@/api/studyService'

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    nowRow: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        roomNumber: '',
        classPost: '',
      },
    };
  },
  created() {
    const { roomNumber, classPost } = this.nowRow
    this.form = { roomNumber, classPost }
  },
  methods: {
    toNull(str) {
      if (!str) {
        return null;
      } else {
        return str
      }
    },
    sureEdit() {
      const { classPost, roomNumber } = this.form
      $LiaisonUserUpdate({ classPost: this.toNull(classPost), roomNumber: this.toNull(roomNumber), uuid: this.nowRow.uuid }, () => {
        this.closeDialog(true)
      })
    },
    closeDialog(flag = false) {
      this.$emit("close", flag);
    },
  },
};
</script>

<style lang="scss" scoped>
.line-30 {
  line-height: 30px;
}
</style>
